import { j as r } from "../jsx-runtime-ClSzPYp4.js";
import { s } from "../index.esm-DOxVcNnO.js";
import { styled as n, css as p } from "styled-components";
import { typography as c } from "styled-system";
import { Flex as d, flexModifiers as l } from "../Flexbox/Flexbox.mjs";
import m from "../Icon/Icons/AlertIcon.mjs";
import "../Icon/StyledPath.mjs";
import f from "../Icon/Icons/InfoIcon.mjs";
const x = /* @__PURE__ */ n.span.withConfig({
  shouldForwardProp: s
}).withConfig({
  componentId: "sc-cd690c77-0"
})([
  "",
  " ",
  ""
], ({ theme: e }) => /* @__PURE__ */ p([
  "",
  ""
], e.components.helperText.base), c), h = /* @__PURE__ */ n(d).withConfig({
  shouldForwardProp: (e) => ![
    "variant"
  ].includes(e) && s(e)
}).attrs({
  alignItems: "flex-start",
  gap: "xs"
}).withConfig({
  componentId: "sc-cd690c77-1"
})([
  "",
  ""
], ({ theme: e, variant: o }) => /* @__PURE__ */ p([
  "",
  " ",
  " ",
  ""
], e.components.helperText.wrapper, o && e.components.helperText[o], l)), q = ({ variant: e = "default", wrapperProps: o, showIcon: i = !0, ...a }) => {
  const t = {
    error: m,
    alert: f,
    default: void 0,
    success: void 0
  }[e];
  return /* @__PURE__ */ r.jsxs(h, {
    variant: e,
    ...o,
    "data-qa-id": "helper-text-wrapper",
    children: [
      i && t && /* @__PURE__ */ r.jsx(t, {
        "data-qa-id": "helper-text-icon",
        color: "currentColor",
        size: 18
      }),
      /* @__PURE__ */ r.jsx(x, {
        "data-qa-id": "helper-text",
        ...a
      })
    ]
  });
};
export {
  x as StyledHelperText,
  h as Wrapper,
  q as default
};
